const UploadIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3337 3.00309C15.7069 3 15.0412 3 14.3337 3C8.36254 3 5.37697 3 3.52198 4.85499C1.66699 6.70998 1.66699 9.69554 1.66699 15.6667C1.66699 21.6378 1.66699 24.6234 3.52198 26.4783C5.37697 28.3333 8.36254 28.3333 14.3337 28.3333C20.3048 28.3333 23.2903 28.3333 25.1453 26.4783C26.93 24.6937 26.9977 21.8626 27.0002 16.3333"
        stroke="#012C68"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M1.66699 17.8472C2.49235 17.7273 3.32678 17.6681 4.16261 17.6702C7.69853 17.5955 11.1478 18.6972 13.8951 20.7789C16.443 22.7095 18.2333 25.3665 19.0003 28.3333"
        stroke="#012C68"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M27 21.5283C25.4327 20.7345 23.8117 20.3318 22.1816 20.3335C19.7127 20.3237 17.2687 21.2312 15 23"
        stroke="#012C68"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M21.667 4.99996C22.3224 4.32569 24.0667 1.66663 25.0003 1.66663M28.3337 4.99996C27.6783 4.32569 25.934 1.66663 25.0003 1.66663M25.0003 1.66663V12.3333"
        stroke="#012C68"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UploadIcon;
